import {Component} from '@angular/core';
import {FormValueListEntryDto} from "../../../core/interfaces/core.types";
import {SignUpService} from "../../service/sign-up.service";
import {MenuItem} from "primeng/api";
import {RegistrationBaseComponent} from "../registration-base-component/registration-base-component";
import {CoreApiService} from "../../../core/service/core-api.service";
import {RegistrationApiService} from "../../api/registration-api.service";
import { PrimeNGConfig } from 'primeng/api';



@Component({
  selector: 'registration-personal-info',
  templateUrl: './registration-personal-info.component.html',
  styleUrls: ['./registration-personal-info.component.scss']
})
export class RegistrationPersonalInfoComponent extends RegistrationBaseComponent {

  genderOptions: FormValueListEntryDto[] | undefined;
  maritalStatus: FormValueListEntryDto[] | undefined;
  addressOptions: MenuItem[] | undefined;
  maxDate: Date = new Date();
  minDate: Date = new Date();
  defaultDate: Date = new Date();
  ageDetails: string | undefined;
  noOfChildrenOptions: MenuItem[] = [
    {key: 0, label: '0'},
    {key: 1, label: '1'},
    {key: 2, label: '2'},
    {key: 3, label: '3'},
    {key: 4, label: '4'},
    {key: 5, label: '5'},
    {key: 6, label: '6'},
    {key: 7, label: '7'},
    {key: 8, label: '8'},
    {key: 9, label: '9'},
    {key: 10, label: '10'},
  ]


  constructor(protected override registrationApiService: RegistrationApiService,
              protected override  signUpService: SignUpService,
              private primengConfig: PrimeNGConfig,
              protected override coreApiService: CoreApiService) {
    super(registrationApiService,signUpService,coreApiService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  override initComponent() {
    if (this.formGroup) {
      const formFields = this.signUpService.registrationForm.formFields;
      this.genderOptions = formFields['gender'].valueList.entries;
      this.maritalStatus = formFields['maritalStatus'].valueList.entries;
      this.maritalStatus?.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));

      //set min and max dates for calendar
      const today = new Date();
      this.maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
      this.minDate = new Date(today.getFullYear() - 99, today.getMonth(), today.getDate());
      this.defaultDate = this.maxDate;

      // this.primengConfig.setTranslation({
      //   // Define all your translations and locale-specific configurations here
      //   dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
      //   dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      //   dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      //   monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
      //   monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      //   today: 'Heute',
      //   clear: 'Löschen',
      // });

      this.addressOptions = [
        {label: 'Du', key: true},
        {label: 'Sie', key: false}
      ];
    }

    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  override refreshComponent() {

    this.initialized = true;
  }

  isFormValid(): boolean {
    const fields = ['firstName', 'lastName', 'gender','addressCasually', 'dateOfBirth']
    return this.isActiveFormValid(fields);
  }

  override postObjectRefresh() {
    this.navigateNextStep(1);
  }


  formatDateInputOnInput(event: any) {
    const inputElement = event.target;
    const inputValue = inputElement.value;

    if (!inputValue) {
      return;
    }

    // Remove non-numeric characters
    const numericValue = inputValue.replace(/\D/g, '');

    // Check if the numericValue has enough characters for a complete date
    if (numericValue.length == 8) {

      // Parse substrings to integers
      const day = parseInt(numericValue.substring(0, 2), 10);
      const month = parseInt(numericValue.substring(2, 4), 10);
      const year = parseInt(numericValue.substring(4, 8), 10);

      if (this.isValidDate(year, month, day)) {
        this.handleDate(new Date(year, month - 1, day));
        this.calculateAge(new Date(year, month - 1, day))
      } else {
        this.handleDate(undefined); // Invalid date
        this.ageDetails = undefined;
      }

    }
  }

  isValidDate(year: number, month: number, day: number): boolean {
    const dateOfBirth = new Date(year, month - 1, day);
    const today = new Date();

    //check if the customer is eligible (must be 18+ and 100-)
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    const ninetyNineYearsAgo = new Date(today.getFullYear() - 99, today.getMonth(), today.getDate());

    return (
      dateOfBirth.getFullYear() === year &&
      dateOfBirth.getMonth() === month - 1 &&
      dateOfBirth.getDate() === day &&
      dateOfBirth <= eighteenYearsAgo &&
      dateOfBirth >= ninetyNineYearsAgo
    );
  }

  handleDate(date: Date | undefined) {

    if (!date) {
      this.formGroup.get('dateOfBirth')?.setValue(null);
    }

    this.formGroup.get('dateOfBirth')?.setValue(date);

  }

  calculateAge(dateOfBirth: Date) {
    this.ageDetails = this.calculateDetailedAge(new Date(dateOfBirth));
  }

  // calculateDetailedAge(dateOfBirth: Date): string {
  //   const today = new Date();
  //   let years = today.getFullYear() - dateOfBirth.getFullYear();
  //   let months = today.getMonth() - dateOfBirth.getMonth();
  //   let days = today.getDate() - dateOfBirth.getDate();
  //
  //   if (days < 0) {
  //     // Handle case where the current day is before the birth day
  //     months--;
  //     const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
  //     days += previousMonth.getDate();
  //   }
  //
  //   if (months < 0) {
  //     // Handle case where the current month is before the birth month
  //     years--;
  //     months += 12; // Add months from a full year
  //   }
  //
  //   // Construct the age string
  //   let ageString = `${years} year${years > 1 ? 's' : ''}`;
  //   if (months > 0) {
  //     ageString += `, ${months} month${months > 1 ? 's' : ''}`;
  //   }
  //   if (days > 0) {
  //     ageString += `, and ${days} day${days > 1 ? 's' : ''}`;
  //   }
  //
  //   return ageString;
  // }

  calculateDetailedAge(dateOfBirth: Date): string {
    const today = new Date();
    let years = today.getFullYear() - dateOfBirth.getFullYear();
    let months = today.getMonth() - dateOfBirth.getMonth();
    let days = today.getDate() - dateOfBirth.getDate();

    if (days < 0) {
      // Handle case where the current day is before the birth day
      months--;
      const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0); // Last day of the previous month
      days += previousMonth.getDate();
    }

    if (months < 0) {
      // Handle case where the current month is before the birth month
      years--;
      months += 12; // Add months from a full year
    }

    // Construct the age string in German
    let ageString = `${years} Jahr${years !== 1 ? 'e' : ''}`;
    if (months > 0) {
      ageString += `, ${months} Monat${months !== 1 ? 'e' : ''}`;
    }
    if (days > 0) {
      ageString += ` und ${days} Tag${days !== 1 ? 'e' : ''}`;
    }

    return ageString;
  }


}
